import { homepage } from '../../package.json';
import { GET } from 'utils/http';

let busStopAllocationData = null;
export const fetchBusStopAllocationData = async () => {
	if (!busStopAllocationData) {
		try {
			busStopAllocationData = await GET({
				url: 'bus_configuration/busStopAllocation.json',
				baseURL: window.location.origin + homepage,
			});
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	}
	return busStopAllocationData;
};
